import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Normalize image URLs coming from the database or relative paths.
// - Keeps http(s) URLs as-is
// - Strips leading slashes from app-hosted assets and prefixes with BASE_URL
// - Falls back to a default placeholder when empty
export function imageUrl(path?: string, fallback: string = "/placeholder.svg") {
  const value = (path || "").trim()
  if (!value) return fallback
  if (/^https?:\/\//i.test(value)) return value
  const base = (import.meta.env.BASE_URL as string) || "/"
  const clean = value.replace(/^\/+/, "")
  const url = `${base}${clean}`
  return url.replace(/([^:]\/)\/+/g, "$1/")
}
